import PAApi from './_paApi.js';
import httpClient from '@/apis/base/httpclient';

class PASalaryAPI extends PAApi {
  constructor() {
    super();
  }
  controllerName = 'PASalarys';

  /**
   * Lấy ra dữ liệu để lập bảng lương
   * @param {*} payload
   * @returns
   * tvhien 18.10.2022
   */
  async getPASalary(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/PASalary',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách chứng từ liên quan
   * @param {*} payload
   * @returns
   * tvhien 15.11.2022
   */
  async getRelationVoucher(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getRelationVoucher',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách bảng lương cán bộ theo từng tháng
   * @param {*} payload
   * @returns
   * nnkiem 10.08.2023
   */
  async GetDataSalaryEmployeeByYear(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/SalaryEmployeeByYear',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }


  /**
   * Lấy danh sách chứng từ liên quan
   * @param {*} payload
   * @returns
   * pqdat 15.11.2022
   */
  async getInputPaySalaryRetroactiveForMonth(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/InputPaySalaryRetroactiveForMonth',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

   /**
   * Lấy tham số những lần trước
   * @param {*} payload
   * @returns
   * dvminh 07.04.2023
   */
    async getDataReportC13HD(payload) {
      let apiUrl = this.getAPIUrl();
  
      let request = {
        url: apiUrl + '/ParamReportC13HD',
        data: payload,
      };
  
      return await httpClient.getAsync(request);
    }

  /**
   * Hàm lấy danh sách bảng lương để trả lương
   * @returns
   * NNLINH 19.10.2022
   */
  async GetComboboxPAPaySalary() {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/ComboboxPaySalary',
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy danh sách bảng lương để trả lương
   * @returns
   * TTLONG 19.10.2022
   */
  async GetComboboxPASalaryAllocation(payload, type) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/ComboboxSalaryAllocation?type=${type}`,
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy danh sách bảng lương để trả lương
   * @param {*} payload
   * @returns
   * NNLINH 20.09.2022
   */
  async GetDataPaySalary(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataPaySalary',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy danh sách bảng lương để trả lương
   * @param {*} payload
   * @returns
   * NMDUC1 10.11.2022
   */
  async GetDataPayUnionInsurance(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataPayUnionInsurance',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu sinh chứng từ trả lương
   * @param {*} payload
   * @returns
   * NNLINH 20.09.2022
   */
  async GetDataGenerateVoucherBySalary(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataGenerateVoucher',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy về dữ liệu tính lương theo tháng
   * @param {*} month
   * @returns
   */
  async getSalaryByMonth(month, year) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + `/GetSalaryByMonth?month=${month}&year=${year}`,
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Kiểm tra xem đã có dữ liệu bảng lương theo kỳ hay chưa
   * npcuong 30.12.2022
   */
  async checkHasSalaryData(periodTime, periodYear) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + `/CheckHasSalaryData?periodTime=${periodTime}&periodYear=${periodYear}`,
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Cập nhật dữ liệu thuế vào bảng lương
   * @param {*} param
   * @returns
   */
  async updateIncomeTaxIntoSalary(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/UpdateIncomeTaxIntoSalary',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

  /**
   * Lấy dánh sách cột cần tính lương theo ref type
   * @param {*} payload
   * @returns
   * tvhien 15.11.2022
   */
  async getDataPayrollItemColumn(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetDataPayrollItemColumn',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin phục vụ tính truy lĩnh lương
   * @returns
   * NMDUC1 20/10/2022
   */
  async getPASalaryRetroParam(accountingObjectIdList) {
    let request = {
      url: this.getAPIUrl() + '/GetPASalaryRetroParam',
      data: accountingObjectIdList,
    };

    return await this.postAsync(request);
  }

  /**
   * Lấy thông tin danh sách khoản lương kéo theo
   * @returns
   * NMDUC1 20/10/2022
   */
  async getPayrollRef(payroll_item_code) {
    let request = {
      url: this.getAPIUrl() + '/payroll_ref/' + payroll_item_code,
    };

    return await this.getAsync(request);
  }

  /**
   * Lấy DỮ liệu khi mở form tham số truy lĩnh nâng lương
   * @returns
   * NMDUC1 20/10/2022
   */
  async getBeforeOpenData() {
    let request = {
      url: this.getAPIUrl() + '/BeforeOpenData',
    };

    return await this.getAsync(request);
  }

  /**
   * Hàm kiểm tra dữ liệu đã được sử dụng cho bảng lương chưa
   * @param {*} records
   * @returns
   * nmduc1 6.12.2022
   */
  async checkDataUseRetroSalary(records) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/CheckDataUseRetroSalary',
      data: records,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách cán bộ theo loại cán bộ
   * @param {*} records
   * @returns
   * nmduc1 9.12.2022
   */
  async getEmployeeByEmployeeType(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetEmployeeByEmployeeType',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy thêm thông tin cán bộ truyền vào bảng tại form tham số truy lĩnh nâng lương
   * @returns
   * NMDUC1 19.12.2022
   */
  async getEmployeesByEmployeeIDs(employeeList, payroll_item_id) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/GetEmployeesByEmployeeIDs?payroll_item_id=${payroll_item_id}`,
      data: employeeList,
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Cập nhật dữ liệu cột thêm mới trong mấu vào chi tiết bảng lương
   * TTLONG 13.02.2023
   */
  async updateNewColumnForSalary(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/UpdateNewColumnForSalary?paLayoutTemplateId=${payload.paLayoutTemplateId}`,
      data: payload.newColumns,
    };

    return await httpClient.putAsync(request);
  }

  /**
   * Hàm lấy danh sách các chứng từ để hạch toán chi phí lương và bảo hiểm (Salagov)
   * @param {*} payload
   * @returns
   * NHANH3 10.2.2023
   */
  async getVoucherAccountingSalaryAndInsurance(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/GetVoucherAccountingSalaryAndInsurance`,
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm sinh chứng từ hạch toán chi phí lương và bảo hiểm (Salagov)
   * @param {*} payload
   * @returns
   * NHANH3 14.2.2023
   */
  async getDataGenerateAccountingVoucher(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/DataGenerateAccountingVoucher`,
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Kiểm tra xem đã có dữ liệu bảng lương theo kỳ hay chưa
   * PQDat 30.12.2022
   */
  async getSalaryTableSalagov(model) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + `/SalaryTableSalagov?month=${model.pa_month}&year=${model.pa_year}`,
    };
    return await httpClient.getAsync(request);
  }
  /**
   * lấy dữ liệu sinh chứng từ theo tham số từ Salagov
   * PQDat 30.12.2022
   */
  async getDataSalaryTableSalagovInsurance(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetDataSalaryTableSalagovInsurance',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

  /**
   * lấy dữ bảng lương từ Salagov v2
   * NHANH3 21.08.2024
   */
  async getDataSalaryTableSalagovInsuranceV2(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetDataSalaryTableSalagovInsuranceV2',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

  /**
   * Hàm sinh chứng từ giấy rút từ salagov
   * @param {*} payload
   * @returns
   * NNLINH 16.02.2023
   */
  async GenerateDataVoucherSalaGov(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/DataVoucherSalaGov`,
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm sinh chứng từ giấy rút từ salagov v2
   * @param {*} payload
   * @returns
   * NHANH3 26.08.2024
   */
  async GenerateDataVoucherSalaGovV2(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/DataVoucherSalaGovV2`,
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * lấy dữ liệu sinh chứng từ theo tham số từ Salagov
   * PQDat 30.12.2022
   */
  async checkExistSalarySala(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/CheckExistSalarySala',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

   /**
   * Kiểm tra số chứng từ đã tồn tại
   * NNLINH 12.07.2023
   */
    async checkExistRefNo(payload) {
      let apiUrl = this.getAPIUrl();
      let request = {
        url: apiUrl + '/ExistRefNo',
        data: payload,
      };
      return await httpClient.postAsync(request);
    }
  
  /**
   * Lấy danh sách bảng lương, truy lĩnh có thể nộp bảo hiểm, công đoàn phí
   * NHANH3 22.04.2024
   */
  async getSalaryPayInsurance(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetSalaryPayInsurance',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }
}

export default new PASalaryAPI();
